import Index from '@/views/Index.js'
import Logout from '@/views/Logout.js'

/**
 * ログイン必須のルート
 */
export default [
  {
    path: "/",
    name: "index",
    component: Index
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/top",
    name: "top",
    component: () =>
      import(
        /* webpackChunkName: "top" */
        "../views/top/Index.vue"
      )
  },
  {
    path: "/account",
    name: "account.index",
    component: () =>
      import(
        /* webpackChunkName: "account_index" */
        "../views/account/Index.vue"
      )
  },
  {
    path: "/member",
    name: "member.index",
    component: () =>
      import(
        /* webpackChunkName: "member_index" */
        "../views/member/Index.vue"
      )
  },
  {
    path: "/password",
    name: "password.index",
    component: () =>
      import(
        /* webpackChunkName: "password_index" */
        "../views/password/Index.vue"
      )
  },
  {
    path: "/static/:id",
    name: "static.index",
    component: () =>
      import(
        /* webpackChunkName: "static_index" */
        "../views/static/Index.vue"
      )
  },
  {
    path: '/visit/',
    name: 'visit.index',
    parent: 'use-history.index',
    component: () => import(
      /* webpackChunkName: "visit_index" */
      '../views/visit/Index.vue'
    )
  },
  {
    path: '/visit/:visitorId/history/:historyId',
    name: 'visit.show',
    parent: 'use-history.index',
    component: () => import(
      /* webpackChunkName: "visit_show" */
      '../views/visit/Show.vue'
    )
  },
  {
    path: '/use-history',
    name: 'use-history.index',
    component: () => import(
      /* webpackChunkName: "use-history_index" */
      '../views/use-history/Index.vue'
    )
  },
  {
    path: '/category/:id?',
    name: 'category.index',
    component: () => import(
      /* webpackChunkName: "category_index" */
      '../views/category/Index.vue'
    )
  },
  {
    path: "/question",
    name: "question.index",
    component: () =>
      import(
        /* webpackChunkName: "question_index" */
        "../views/question/Index.vue"
      )
  },
  {
    path: "/question/:dialogId/answer",
    name: "question.answer",
    parent: "question.index",
    component: () =>
      import(
        /* webpackChunkName: "question_answer" */
        "../views/question/Answer.vue"
      )
  },
  {
    path: "/question/:dialogId",
    name: "question.show",
    parent: "question.index",
    component: () =>
      import(
        /* webpackChunkName: "question_show" */
        "../views/question/Show.vue"
      )
  },
  {
    path: "/step/:id?",
    name: "step.index",
    component: () =>
      import(
        /* webpackChunkName: "step_show" */
        "../views/step/Index.vue"
      )
  },
  {
    path: "/step/:stepId/task-status/create",
    name: "step.task.create",
    parent: "step.index",
    props: { type: 'create' },
    component: () =>
      import(
        /* webpackChunkName: "step_task_create" */
        "../views/step/TaskEdit.vue"
      )
  },
  {
    path: "/step/:stepId/task/:taskId/edit",
    name: "step.task.edit",
    parent: "step.index",
    props: { type: 'edit' },
    component: () =>
      import(
        /* webpackChunkName: "step_task_edit" */
        "../views/step/TaskEdit.vue"
      )
  },
  {
    path: "/step/:stepId/task-status/:taskId/edit",
    name: "step.task-status.edit",
    parent: "step.index",
    props: { type: 'edit.status' },
    component: () =>
      import(
        /* webpackChunkName: "step_task-status_edit" */
        "../views/step/TaskEdit.vue"
      )
  },
  {
    path: "/meeting",
    name: "meeting.index",
    component: () =>
      import(
        /* webpackChunkName: "meeting_index" */
        "../views/meeting/Index.vue"
      )
  },
  {
    path: "/reservation",
    name: "reservation.index",
    component: () =>
      import(
        /* webpackChunkName: "reservation_index" */
        "../views/reservation/Index.vue"
      )
  },
  {
    path: "/document",
    name: "document.index",
    component: () =>
      import(
        /* webpackChunkName: "document_index" */
        "../views/document/Index.vue"
      )
  },
  {
    path: "/producer",
    name: "producer.index",
    component: () =>
      import(
        /* webpackChunkName: "producer_index" */
        "../views/producer/Index.vue"
      )
  },
  {
    path: "/bridal-item",
    name: "bridal-item.index",
    component: () =>
      import(
        /* webpackChunkName: "bridal-item_index" */
        "../views/bridal-item/Index.vue"
      )
  },
  {
    path: "/bridal-item/:groupId/subgroup/:subgroupId?",
    name: "bridal-item.show",
    parent: "bridal-item.index",
    component: () =>
      import(
        /* webpackChunkName: "bridal-item_show" */
        "../views/bridal-item/Show.vue"
      )
  },
  {
    path: "/bridal-item/:groupId/coordinate",
    name: "bridal-item.coordinate",
    parent: "bridal-item.index",
    component: () =>
      import(
        /* webpackChunkName: "bridal-item_coordinate" */
        "../views/bridal-item/Coordinate.vue"
      )
  },
  {
    path: "/bridal-item/favorite",
    name: "bridal-item.favorite",
    parent: "bridal-item.index",
    component: () =>
      import(
        /* webpackChunkName: "bridal-item_favorite" */
        "../views/bridal-item/Favorite.vue"
      )
  },
  {
    path: "/collage/:id?",
    name: "collage.index",
    component: () =>
      import(
        /* webpackChunkName: "collage_index" */
        "../views/collage/Index.vue"
      )
  },
  {
    path: "/simulation/:id?",
    name: "simulation.index",
    component: () =>
      import(
        /* webpackChunkName: "simulation_index" */
        "../views/simulation/Index.vue"
      )
  },
  {
    path: "/simulation-collage-history",
    name: "simulation-collage-history.index",
    component: () =>
      import(
        /* webpackChunkName: "simulation-collage-history_index" */
        "../views/simulation-collage-history/Index.vue"
      )
  },
  {
    path: "/groom-information",
    name: "groom-information.index",
    component: () =>
      import(
          /* webpackChunkName: "groom-information_index" */
          "../views/groom-information/Index.vue"
      )
  },
  {
    path: "/bride-information",
    name: "bride-information.index",
    component: () =>
      import(
          /* webpackChunkName: "bride-information_index" */
          "../views/bride-information/Index.vue"
      )
  },
  {
    path: "/after-survey",
    name: "after-survey.index",
    component: () =>
      import(
        /* webpackChunkName: "after-survey_index" */
        "../views/after-survey/Index.vue"
      )
  },
  {
    path: "/after-survey/:afterSurveyId/answer",
    name: "after-survey.answer",
    parent: "after-survey.index",
    component: () =>
      import(
        /* webpackChunkName: "after-survey_answer" */
        "../views/after-survey/Answer.vue"
      )
  },
  {
    path: "/after-survey/:afterSurveyId",
    name: "after-survey.show",
    parent: "after-survey.index",
    component: () =>
      import(
        /* webpackChunkName: "after-survey_show" */
        "../views/after-survey/Show.vue"
      )
  },
]
